const getSignature = ({ signature, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (signature && signature.length > 0) {
    return signature;
  }
  return null;
};

export default getSignature;



// WEBPACK FOOTER //
// ./src/utils/print/getSignature.js